export default "__VITE_ASSET__BSAFUflx__"